export enum ServiceBookingQueryStatus {
  /**
   * The booking has been made. No payment or further confirmation required.
   */
  ACCEPTED = "accepted",

  /**
   * The booking requires payment and has an active attached checkout.
   */
  REQUIRES_PAYMENT = "checkout",

  /**
   * The booking has been made, but needs the agent to confirm it.
   */
  PENDING = "pending",

  /**
   * The requested service(s) could not be booked with the request parameters.
   */
  UNAVAILABLE = "unavailable",

  /**
   * An error occurred.
   */
  ERROR = "error",
}

export enum ServiceBookingError {
  INVALID_INPUT = "301",
  UNAVAILABLE = "302",
  NO_GUESTS = "303",
  NO_MEMBERS = "304",
  NO_LOCATION = "305",
  INVALID_LOCATION = "306",
  CANNOT_RESCHEDULE = "307",
  OUT_OF_BOUNDS = "308",
  LIMITS_REACHED = "309",
}

export enum ServiceBookingStatus {
  /**
   * Booking was cancelled by the booker.
   */
  CANCELLED = "cancelled",

  /**
   * Booking was accepted (either automatically or by provider)
   */
  ACCEPTED = "accepted",

  /**
   * Booking was rejected by provider.
   */
  REJECTED = "rejected",

  /**
   * Booking has been made, pending.
   */
  PENDING = "pending",
}
